type BaseRoute = string;

export const TEMPLATES_INDEX = '/templates';
export const CAMPAIGN_INDEX = '/campaigns';
export type VALID_DESTINATIONS = typeof TEMPLATES_INDEX | typeof CAMPAIGN_INDEX;
type SearchString = `?${string}`; // a search string off a location starts with ?

type RouteAndModifierFn = [BaseRoute, (searchString: SearchString) => VALID_DESTINATIONS];

/**
 * Template editing routes redirect to the campaign index page if a
 * `campaignId` search query is present
 */
export function getTemplateEditRedirectRoute(searchString: SearchString) {
  if (searchString.includes('campaignId=')) return CAMPAIGN_INDEX;

  return TEMPLATES_INDEX;
}

/**
 *
 * Certain routes need redirects when active and the project is switched
 * Given a URL like /templates/edit?templateId=89823423
 * Reroute to /templates (or to `/campaigns` if user is navigating from Campaigns Index page)
 * Move from `/templates/edit?templateId=[someId]` => `/templates`
 */
export const REDIRECTABLE_ROUTES: RouteAndModifierFn[] = [
  ['/templates/edit', getTemplateEditRedirectRoute],
  ['/templates/editor', getTemplateEditRedirectRoute],
];

/**
 * Check if the list of redirectable routes includes the given pathname
 */
export function shouldNavigateBackToIndex(path: string) {
  return REDIRECTABLE_ROUTES.map(([route]) => route).includes(path);
}

/**
 * Derive the destination based on the view's pathname and search
 */
export function getRedirectDestination(path: string, searchString: SearchString = '?') {
  const matchedRoute = REDIRECTABLE_ROUTES.find(([route]) => route === path);
  if (matchedRoute) {
    return matchedRoute[1](searchString);
  }

  /**
   * This should never be hit because this fn is downstream of a valid
   * shouldNavigateBackToIndex check
   */
  throw new Error(`No given redirect for ${path}${searchString}`);
}
